import { FunctionComponent } from 'react';
import Progress from 'src/designSystem/Progress';
import BackArrowButton from 'src/components/Header/BackArrowButton';
import CloseButton from 'src/designSystem/CloseButton';
import PageHeader from 'src/designSystem/PageHeader';
import { projectColors } from 'src/styles/project-styles';
import { LessonFlowStep, lessonFlowProgress } from 'src/utils/lessonFlowSteps';

type Props = {
  step: LessonFlowStep;
  total: number;
  fraction?: number;
  onClose?: () => void;
  onBack?: () => void;
};

const LessonFlowHeader: FunctionComponent<Props> = ({
  step,
  total,
  fraction,
  onClose,
  onBack,
}) => (
  <PageHeader
    left={
      onClose ? (
        <CloseButton onClick={onClose} data-testid="btn-close-flow" />
      ) : (
        <BackArrowButton onClick={onBack} />
      )
    }
  >
    <div className="w-full max-w-xs">
      <Progress
        value={lessonFlowProgress({ step, total, fraction })}
        color={projectColors.primary.darkest}
        backgroundColor={projectColors.structural.lighter}
        height={16}
        animated
        data-testid="lesson-flow-progress-bar"
      />
    </div>
  </PageHeader>
);

export default LessonFlowHeader;
